import { useEffect } from 'react';

export function useInjectKatexCssIntoShadowDom(headElements: HTMLHeadElement[]) {
  useEffect(() => {
    if (!headElements.length) return;
    const head = headElements[0];

    if (head.querySelector('#katex-styles')) return;

    const css = getKatexCssForShadowDom();
    if (!css) return;

    const style = document.createElement('style');
    style.id = 'katex-styles';
    style.textContent = css;
    head.appendChild(style);
  }, [headElements]);
}

let cachedKatexCss: string | null = null;

function getKatexCssForShadowDom(): string {
  if (cachedKatexCss !== null) {
    return cachedKatexCss;
  }

  const cssTexts: string[] = [];

  for (const sheet of Array.from(document.styleSheets)) {
    const extracted = tryExtractKatexRules(sheet);
    if (extracted) {
      cssTexts.push(...extracted);
      break;
    }
  }

  if (cssTexts.length === 0) {
    return '';
  }

  cachedKatexCss = cssTexts.join('\n');
  return cachedKatexCss;
}

function tryExtractKatexRules(sheet: CSSStyleSheet): string[] | null {
  try {
    const rules = Array.from(sheet.cssRules)
      .filter(r => !(r instanceof CSSFontFaceRule))
      .map(r => r.cssText);
    return filterKatexRules(rules);
  } catch {
    // Cross-origin stylesheets throw on cssRules access — skip them
    return null;
  }
}

export function filterKatexRules(rules: string[]): string[] | null {
  const isKatexSheet = rules.some(r => r.includes('.katex') || r.includes('KaTeX_'));

  if (!isKatexSheet) return null;

  return rules;
}
